// src/components/ScrollTopButton.js
import React, { useEffect, useState } from "react";

const ScrollTopButton = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const handler = () => {
            if (typeof window === "undefined") return;
            const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
            const percent = scrollTop / (scrollHeight - clientHeight);
            setShow(percent >= 0.25);
        };
        handler();
        window.addEventListener("scroll", handler, { passive: true });
        return () => window.removeEventListener("scroll", handler);
    }, []);

    if (!show) return null;

    return (
        <button
            className='btn btn2 btnIcon'
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            style={{
                position: "fixed",
                right: "2.4rem",
                bottom: "1.4rem",
                zIndex: 9999,
            }}
            aria-label="Вгору"
        >
            <span style={{transform: `rotate(-90deg)`, filter: `brightness(0) invert(1)`}} className='iconBG icon24 iconBG32'></span>
        </button>
    );
};

export default ScrollTopButton;